(function () {
  "use strict";

  const CONTROLLER_VERSION = "1.0.0";
  if (window.__ltCustomProductSectionController === CONTROLLER_VERSION) return;
  window.__ltCustomProductSectionController = CONTROLLER_VERSION;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function safeJsonParse(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  const sectionInstances = new WeakMap();

  function initSection(el) {
    if (!el) return;

    const existingInstance = sectionInstances.get(el);
    if (existingInstance) {
      existingInstance.refresh();
      return;
    }

    el.dataset.ltcpsInit = "true";

    const slides = Array.from(el.querySelectorAll("[data-slide]"));
    if (!slides.length) return;

    const uiTitles = Array.from(el.querySelectorAll("[data-ui-title]"));
    const uiPillsEls = Array.from(el.querySelectorAll("[data-ui-pills]"));
    const uiTabs = el.querySelector("[data-ui-tabs]");
    const btnPrev = el.querySelector("[data-prev]");
    const btnNext = el.querySelector("[data-next]");
    const exploreFixed = el.querySelector("[data-explore-fixed]");
    const refractionCanvas = document.createElement("canvas");

    refractionCanvas.className = "lt-liquid-glass__refraction";
    refractionCanvas.setAttribute("data-lt-liquid-refraction", "");
    refractionCanvas.setAttribute("aria-hidden", "true");

    let refraction = null;
    let refractionOwner = null;

    let active = 0;

    function readSlideData(i) {
      const s = slides[i];
      return {
        href: s.getAttribute("data-href") || "#",
        tab: s.getAttribute("data-tab") || "",
        title: s.getAttribute("data-title") || "",
        features: safeJsonParse(s.getAttribute("data-features") || "[]") || []
      };
    }

    function renderPills(list) {
      uiPillsEls.forEach((uiPills) => {
        uiPills.innerHTML = "";
        (list || []).slice(0, 6).forEach((txt) => {
          const clean = String(txt || "").trim();
          if (!clean) return;
          const li = document.createElement("li");
          li.textContent = "+ " + clean;
          uiPills.appendChild(li);
        });
      });
    }

    function setExploreHref(href) {
      if (exploreFixed) exploreFixed.href = href;

      slides.forEach((s) => {
        const a = s.querySelector("[data-explore-float]");
        if (a) a.href = href;
      });
    }

    function releaseRefraction(owner) {
      if (owner && refractionOwner !== owner) return;
      refraction?.destroy();
      refraction = null;
      refractionOwner = null;
      refractionCanvas.remove();
    }

    function attachRefraction(slide, exploreFloat, glass) {
      if (
        refractionOwner === slide &&
        refraction &&
        refractionCanvas.parentElement === glass
      ) {
        return refraction;
      }

      releaseRefraction();

      const image = slide.querySelector(".ltcps__img");
      const overlay = slide.querySelector(".ltcps__overlay");
      if (!image || !window.LTLiquidGlassRefraction) return null;

      glass.prepend(refractionCanvas);
      refraction = window.LTLiquidGlassRefraction.create({
        root: exploreFloat,
        surface: glass,
        canvas: refractionCanvas,
        image: image,
        stage: slide,
        overlay: overlay
      });
      refractionOwner = slide;
      return refraction;
    }

    /* LT Liquid Glass: shared Explore follower using the frozen v1 physics. */
    function makeFollowController(slide) {
      const exploreFloat = slide.querySelector("[data-explore-float]");
      const glass = exploreFloat?.querySelector(".lt-liquid-glass__surface");

      if (!exploreFloat || !glass || !window.LTLiquidGlass) {
        return {
          sync: function () {},
          deactivate: function () {},
          destroy: function () {}
        };
      }

      const follower = window.LTLiquidGlass.createFollow({
        boundary: slide,
        host: exploreFloat,
        surface: glass,
        isActive: function () {
          return globalThis.innerWidth >= 750 && slide.classList.contains("is-active");
        },
        onRender: function (snapshot) {
          if (refractionOwner === slide) refraction?.render(snapshot);
        },
        onVisibilityChange: function (visible) {
          if (visible) {
            attachRefraction(slide, exploreFloat, glass)?.setVisible(true);
          } else if (refractionOwner === slide) {
            refraction?.setVisible(false);
          }
        }
      });

      return {
        sync: follower.sync,
        deactivate: follower.deactivate,
        destroy: function () {
          follower.destroy();
          releaseRefraction(slide);
        }
      };
    }

    const followControllers = slides.map(makeFollowController);

    function setActive(i, fromUser) {
      const next = (i + slides.length) % slides.length;
      active = next;

      slides.forEach((s, idx) => {
        s.classList.toggle("is-active", idx === active);
      });

      const data = readSlideData(active);

      uiTitles.forEach((t) => (t.textContent = data.title));
      renderPills(data.features);
      setExploreHref(data.href);

      if (uiTabs) {
        const tabButtons = Array.from(uiTabs.querySelectorAll("[data-tab-btn]"));
        tabButtons.forEach((b) => {
          const idx = parseInt(b.getAttribute("data-tab-btn"), 10);
          b.setAttribute("aria-selected", idx === active ? "true" : "false");
        });
      }

      // ✅ important: when slide changes, resync to cursor
      // so if the cursor is already sitting there, the button "finds" it
      followControllers.forEach((c, idx) => {
        if (idx !== active) c.deactivate();
      });
      if (refractionOwner && refractionOwner !== slides[active]) {
        releaseRefraction(refractionOwner);
      }
      followControllers[active]?.sync({ forceJumpToCursor: true });

      if (fromUser) restartAutoplay();
    }

    if (uiTabs && slides.length > 1) {
      uiTabs.innerHTML = "";
      slides.forEach((s, idx) => {
        const label = s.getAttribute("data-tab") || "Tab " + (idx + 1);

        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ltcps__tab";
        btn.setAttribute("role", "tab");
        btn.setAttribute("data-tab-btn", String(idx));
        btn.setAttribute("aria-selected", idx === 0 ? "true" : "false");
        btn.textContent = label;

        btn.addEventListener("click", () => setActive(idx, true));
        uiTabs.appendChild(btn);
      });
    }

    if (btnPrev) btnPrev.addEventListener("click", () => setActive(active - 1, true));
    if (btnNext) btnNext.addEventListener("click", () => setActive(active + 1, true));

    /* ✅ Scroll/resize sync (throttled with rAF so we don’t murder performance) */
    let syncRaf = null;
    function requestSync() {
      if (syncRaf) return;
      syncRaf = requestAnimationFrame(() => {
        syncRaf = null;
        followControllers[active]?.sync();
        if (globalThis.innerWidth < 750) releaseRefraction();
      });
    }

    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", requestSync);

    const autoplayEnabled = el.getAttribute("data-autoplay") === "true";
    const seconds = parseInt(el.getAttribute("data-autoplay-seconds") || "6", 10);
    const ms = clamp(seconds, 2, 12) * 1000;

    let timer = null;

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length < 2) return;
      stopAutoplay();
      timer = window.setInterval(() => setActive(active + 1, false), ms);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    setActive(0, false);
    startAutoplay();

    const stage = el.querySelector("[data-stage]");
    if (stage) stage.addEventListener("pointerdown", restartAutoplay);

    // ✅ one extra sync on init, in case cursor is already parked over it
    requestSync();

    const instance = {
      refresh: requestSync,
      destroy: function () {
        stopAutoplay();
        if (syncRaf) cancelAnimationFrame(syncRaf);
        syncRaf = null;
        followControllers.forEach((controller) => controller.destroy());
        releaseRefraction();
        window.removeEventListener("scroll", requestSync);
        window.removeEventListener("resize", requestSync);
        if (stage) stage.removeEventListener("pointerdown", restartAutoplay);
        delete el.dataset.ltcpsInit;
        sectionInstances.delete(el);
      }
    };

    sectionInstances.set(el, instance);
  }

  function getSections(root) {
    const scope = root || document;
    const sections = [];
    if (scope.matches?.("[data-ltcps]")) sections.push(scope);
    scope.querySelectorAll?.("[data-ltcps]").forEach((section) => sections.push(section));
    return sections;
  }

  function initAll(root) {
    getSections(root).forEach(initSection);
  }

  function destroyAll(root) {
    getSections(root).forEach((section) => sectionInstances.get(section)?.destroy());
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document));
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:select", (e) => initAll(e.target));
  document.addEventListener("shopify:section:unload", (e) => destroyAll(e.target));
})();